module.exports = __webpack_public_path__ + "img/avatar1.cd9f0b28.png";